<div class="calculadora-container" [class.is-dan-mode]="isDanMode" [class.is-gup-mode]="!isDanMode">
  <header>
    <div class="title-group">
      <h1>Calculadora de Promedios</h1>
    </div>
    <div class="toggle-container">
      <span class="toggle-label" [class.active]="!isDanMode">GUP</span>
      <label class="switch">
        <input type="checkbox" [(ngModel)]="isDanMode" (change)="toggleMode()">
        <span class="slider round"></span>
      </label>
      <span class="toggle-label" [class.active]="isDanMode">DAN</span>
    </div>
  </header>

  <div class="calculadora-form">
    <!-- GUP MODE VERSION - simplified inline layout -->
    <div class="gup-sections" *ngIf="!isDanMode">
      <div class="gup-section">
        <label for="forma1-gup">Forma:</label>
        <input type="number" id="forma1-gup" [(ngModel)]="forma1" min="4" max="9" step="0.5" required (input)="calcular()">
      </div>
      
      <div class="gup-section">
        <label for="combate1p-gup">Combate a 1, 2 o 3 Pasos:</label>
        <input type="number" id="combate1p-gup" [(ngModel)]="combate1p" min="4" max="9" step="0.5" required (input)="calcular()">
      </div>
      
      <div class="gup-section">
        <label for="combinacion-gup">Combinaciones:</label>
        <input type="number" id="combinacion-gup" [(ngModel)]="combinacion" min="4" max="9" step="0.5" required (input)="calcular()">
      </div>
      
      <div class="gup-section">
        <label for="ejerciciosEsp-gup">Ejercicios Especiales:</label>
        <input type="number" id="ejerciciosEsp-gup" [(ngModel)]="ejerciciosEsp" min="4" max="9" step="0.5" required (input)="calcular()">
      </div>
      
      <div class="gup-section">
        <label for="rotura1-gup">Rotura:</label>
        <input type="number" id="rotura1-gup" [(ngModel)]="rotura1" min="4" max="9" step="0.5" (input)="calcular()">
      </div>
      
      <div class="gup-section">
        <label for="luchaTecnica-gup">Lucha:</label>
        <input type="number" id="luchaTecnica-gup" [(ngModel)]="luchaTecnica" min="4" max="9" step="0.5" required (input)="calcular()">
      </div>
      
      <div class="gup-section">
        <label for="teoria-gup">Teoría:</label>
        <input type="number" id="teoria-gup" [(ngModel)]="teoria" min="4" max="9" step="0.5" required (input)="calcular()">
      </div>
    </div>

    <!-- DAN MODE VERSION - original layout -->
    <ng-container *ngIf="isDanMode">
      <!-- FORMA -->
      <div class="section">
        <h2>Forma</h2>
        <div class="input-group">
          <div>
            <label for="forma1">Forma 1:</label>
            <input type="number" id="forma1" [(ngModel)]="forma1" min="4" max="9" step="0.5" required (input)="calcular()">
          </div>
          <div>
            <label for="forma2">Forma 2:</label>
            <input type="number" id="forma2" [(ngModel)]="forma2" min="4" max="9" step="0.5" (input)="calcular()">
          </div>
          <div>
            <label for="forma3">Forma 3:</label>
            <input type="number" id="forma3" [(ngModel)]="forma3" min="4" max="9" step="0.5" (input)="calcular()">
          </div>
        </div>
        <div class="input-group">
          <div>
            <label for="forma4">Forma 4:</label>
            <input type="number" id="forma4" [(ngModel)]="forma4" min="4" max="9" step="0.5" (input)="calcular()">
          </div>
          <div>
            <label for="forma5">Forma 5:</label>
            <input type="number" id="forma5" [(ngModel)]="forma5" min="4" max="9" step="0.5" (input)="calcular()">
          </div>
        </div>
        <div class="result">
          <label>Promedio Forma:</label>
          <span>{{ promedioForma | number:'1.2-2' }}</span>
        </div>
      </div>

      <!-- COMBATE -->
      <div class="section">
        <h2>Combate a 1, 2 o 3 Pasos</h2>
        <div class="input-group">
          <div>
            <label for="combate1p">1 Paso:</label>
            <input type="number" id="combate1p" [(ngModel)]="combate1p" min="4" max="9" step="0.5" required (input)="calcular()">
          </div>
          <div>
            <label for="combate2p">2 Pasos:</label>
            <input type="number" id="combate2p" [(ngModel)]="combate2p" min="4" max="9" step="0.5" (input)="calcular()">
          </div>
          <div>
            <label for="combate3p">3 Pasos:</label>
            <input type="number" id="combate3p" [(ngModel)]="combate3p" min="4" max="9" step="0.5" (input)="calcular()">
          </div>
        </div>
        <div class="result">
          <label>Promedio Combate:</label>
          <span>{{ promedioCombate | number:'1.2-2' }}</span>
        </div>
      </div>

      <!-- COMBINACIONES -->
      <div class="section">
        <h2>Combinaciones</h2>
        <div class="input-group">
          <div>
            <label for="combinacion">Nota:</label>
            <input type="number" id="combinacion" [(ngModel)]="combinacion" min="4" max="9" step="0.5" required (input)="calcular()">
          </div>
        </div>
      </div>

      <!-- EJERCICIOS ESPECIALES -->
      <div class="section">
        <h2>Ejercicios Especiales</h2>
        <div class="input-group">
          <div>
            <label for="ejerciciosEsp">Nota:</label>
            <input type="number" id="ejerciciosEsp" [(ngModel)]="ejerciciosEsp" min="4" max="9" step="0.5" required (input)="calcular()">
          </div>
        </div>
      </div>

      <!-- ROTURA -->
      <div class="section">
        <h2>Rotura</h2>
        <div class="input-group">
          <div>
            <label for="rotura1">Poder:</label>
            <input type="number" id="rotura1" [(ngModel)]="rotura1" min="4" max="9" step="0.5" (input)="calcular()">
          </div>
          <div>
            <label for="rotura2">Habilidad:</label>
            <input type="number" id="rotura2" [(ngModel)]="rotura2" min="4" max="9" step="0.5" (input)="calcular()">
          </div>
          <div>
            <label for="rotura3">Velocidad:</label>
            <input type="number" id="rotura3" [(ngModel)]="rotura3" min="4" max="9" step="0.5" (input)="calcular()">
          </div>
        </div>
        <div class="result">
          <label>Promedio Rotura:</label>
          <span>{{ promedioRotura | number:'1.2-2' }}</span>
        </div>
      </div>

      <!-- LUCHA -->
      <div class="section">
        <h2>Lucha</h2>
        <div class="input-group">
          <div>
            <label for="luchaTecnica">Técnica:</label>
            <input type="number" id="luchaTecnica" [(ngModel)]="luchaTecnica" min="4" max="9" step="0.5" required (input)="calcular()">
          </div>
          <div>
            <label for="luchaEstrategia">Estrategia:</label>
            <input type="number" id="luchaEstrategia" [(ngModel)]="luchaEstrategia" min="4" max="9" step="0.5" (input)="calcular()">
          </div>
          <div>
            <label for="luchaActitud">Actitud:</label>
            <input type="number" id="luchaActitud" [(ngModel)]="luchaActitud" min="4" max="9" step="0.5" (input)="calcular()">
          </div>
        </div>
        <div class="result">
          <label>Promedio Lucha:</label>
          <span>{{ promedioLucha | number:'1.2-2' }}</span>
        </div>
      </div>

      <!-- TEORÍA -->
      <div class="section">
        <h2>Teoría</h2>
        <div class="input-group">
          <div>
            <label for="teoria">Nota:</label>
            <input type="number" id="teoria" [(ngModel)]="teoria" min="4" max="9" step="0.5" required (input)="calcular()">
          </div>
        </div>
      </div>
    </ng-container>

    <!-- RESULT - shared between modes -->
    <div class="final-result" [class.gup-final-result]="!isDanMode">
      <h2>Resultado Final</h2>
      <div class="result">
        <label>Promedio General:</label>
        <span class="final-score">{{ promedioFinal | number:'1.2-2' }}</span>
      </div>
    </div>

    <div class="buttons-container">
      <button type="button" (click)="calcular()">
        <i class="fas fa-calculator"></i> Calcular
      </button>
      <button type="button" (click)="limpiarFormulario()">
        <i class="fas fa-eraser"></i> Limpiar
      </button>
      <button type="button" (click)="imprimirResultado()">
        <i class="fas fa-print"></i> Imprimir
      </button>
    </div>
  </div>
</div>